// extracted by mini-css-extract-plugin
export default {"messages":"_3Ras","spacer":"_3R6K"};